import { ContractedSubscription } from '@/models/order/subscription/contracted/contracted-subscription'
import ContractedSubscriptionDetailContent from '@spa/components/pages/mypage/subscription/contracted/detail/content/ContractedSubscriptionDetailContent.vue'
import LoadErrorContent from '@spa/components/pages/mypage/subscription/contracted/detail/content/LoadErrorContent.vue'
import Vue, { VueConstructor } from 'vue'

export type View = VueConstructor
export interface ContentDisplaySpecification {
  readonly view: View

  readonly dependencies: object
}

const pending: ContentDisplaySpecification = {
  view: Vue.extend({
    template: '<div class="pending"></div>',
  }),
  dependencies: {},
}

interface FulfilledDependencies {
  readonly 'contracted-subscription': ContractedSubscription
}
const createForFulfilled = (dependencies: FulfilledDependencies): ContentDisplaySpecification => ({
  view: ContractedSubscriptionDetailContent,
  dependencies,
})

const errored: ContentDisplaySpecification = {
  view: LoadErrorContent,
  dependencies: {},
}

export const contentDisplaySpecification = {
  pending,
  errored,
  createForFulfilled,
}
